'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCurrentUser = exports.fetchCurrentUser = exports.deserializeUser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializeUser = exports.deserializeUser = function deserializeUser(user) {
  return {
    address: {
      streetAddress: user.street_address,
      extendedAddress: user.extended_address,
      locality: user.locality,
      state: user.state,
      postcode: user.postcode,
      country: user.country_name
    },
    birthday: user.birthday,
    country: user.country_name,
    countryCode: user.country_code,
    email: user.email,
    firstName: user.first_name,
    formattedAddress: user.formattedAddress,
    id: user.id,
    image: null,
    lastName: user.last_name,
    name: user.name,
    pageCount: user.page_ids.length,
    phone: user.phone,
    uuid: user.uuid
  };
};

var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token;
  return (0, _client.get)('api/v1/me', { access_token: token }).then(function (data) {
    return data.user;
  });
};

var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(_ref2) {
  var _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      name = _ref2.name,
      _ref2$address = _ref2.address,
      address = _ref2$address === undefined ? {} : _ref2$address,
      birthday = _ref2.birthday,
      phone = _ref2.phone,
      nickname = _ref2.nickname;
  return (0, _client.put)('api/v1/me?access_token=' + token, {
    user: {
      name: name,
      address: address && _extends({
        street_address: address.streetAddress,
        extended_address: address.extendedAddress,
        postal_code: address.postCode
      }, (0, _omit2.default)(address, ['streetAddress', 'extendedAddress', 'postCode'])),
      birthday: birthday,
      phone: phone,
      nickname: nickname
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/me/everydayhero/index.js
// module id = 1413
// module chunks = 0